// @ts-ignore
import XPaySheet from '@/components/pay_sheet/index.vue'

import { addPortNode } from '../port'
import { h } from '@vue/composition-api'

function showPaySheet(data: {
  preOrderData: any
  onCancel?: () => any
  onConfirm?: (type: any) => any
}) {
  addPortNode(
    h({
      data: () => ({
        visible: false,
      }),

      mounted() {
        // @ts-ignore
        this.visible = true
      },

      render() {
        return h(XPaySheet, {
          props: {
            preOrderData: data.preOrderData,
            value: this.visible,
          },
          on: {
            input: (visible: boolean) => {
              if (!visible) {
                // @ts-ignore
                this.visible = false
              }
            },
            cancel: data.onCancel,
            confirm: data.onConfirm,
          } as any,
        })
      },
    }),
  )
}

export function requestPayment(preOrderData: any): Promise<{
  channel: 'dcb' | 'qsxfj' | 'yzf'
  name: string
  icon: string
  payType?: number
}> {
  return new Promise((resolve, reject) => {
    showPaySheet({
      preOrderData: preOrderData,
      onConfirm: resolve,
      onCancel: reject,
    })
  })
}
